import { PricingCampaignsPage } from '@/pages/pricing-campaigns'
import { createFileRoute, redirect } from '@tanstack/react-router'
import z from 'zod'

import { manager } from '@/shared/lib/modal-manager'

const validateSearch = z.object({
	pc: z.string().optional(),
})
export const Route = createFileRoute('/_app/p/pc/')({
	validateSearch,
	beforeLoad: async ({ search }) => {
		if (search.pc) {
			manager.showModal('PRICING_CAMPAIGN_MODAL', {
				pricingCampaignId: search.pc,
			})

			throw redirect({
				to: '/p/pc',
				replace: true,
			})
		}
	},
	component: PricingCampaignsPage,
})
